import { useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import {
  DialogContent as DialogContentBase,
  type DialogContentComponentProps,
} from "@b2bportal/core-ui";
import { useDeviceType, isWebView } from "@b2bportal/core-utilities";
import clsx from "clsx";
import styles from "./styles.module.scss";

const COMPONENT_KEY = CoreUiComponents.Dialog;

export const DialogContent = (props: DialogContentComponentProps) => {
  const { className } = props;
  const { isMobile: mobile } = useDeviceType();
  const isWebview = isWebView();
  const [block] = useModuleBEM(styles, COMPONENT_KEY, {
    mobile,
    webview: isWebview,
  });
  return <DialogContentBase {...props} className={clsx(block, className)} />;
};
